import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import Signals from 'signals';
import PanelFactory from '../panel-factory';
import PreferenceManager from './preference-manager';
import UtilsService from "../../services/utils.service";


    function DashboardCommon(dataProvider, currentAppId, currentViewId, currentPanelsObservable, currentTabFixedObservable) {
        var self = this;

        self.dataProvider = dataProvider;
        self.currentAppId = currentAppId;
        // gigantic hack since no rooms pages use dashboard-common except the Reporting page
        // future proof it by only checking for existing uses of appId for tabbeddashboards-widget
        self.prefAppId = (currentAppId === 'settings' || currentAppId === 'devicedetails' || currentAppId === 'realtime') ? currentAppId : 'historical2';
        self.currentViewId = currentViewId;
        self.currentPanelsObservable = currentPanelsObservable;
        self.currentTabFixedObservable = currentTabFixedObservable;
        self.currentTabId = 0;
        self.currentTabName = 'Home';
        self.panelFactory = new PanelFactory();
        self.preferenceManager = PreferenceManager;

        self.subscriptions = [
            self.currentPanelsObservable.subscribe(function () {
                if (!self.loadMode) {
                    self.saveCurrentTab();
                }
            })
        ];
    }

    function generateUID() {
        return UtilsService.generateUID(); // returns unique hashes e.g. "j2w4tt8e"
    }

    function getDefaultTabName(tabsList) {
        var defaultTabNames = _.chain(tabsList).map('name').filter(function(tabName) {
            return /^New Dashboard \d+$/i.test(tabName); // tests for names with the following pattern: "New Dashboard xx"
        }).value();

        // Find and index that won't collide with an existing name
        var index = 1;
        var namePrefix = 'New Dashboard ';
        while(_.includes(defaultTabNames, namePrefix + index)) { index++; }

        return namePrefix + index;
    }

    function getAAViewDefaultPrefs(defaultAAPrefs, viewId) {
        return _.chain(defaultAAPrefs).get('views', []).find({ id: viewId }).get([ 'tabs', 0 ]).value();
    }

    function isEmptyAAFirstTab(appId, tabId, tabPrefs) {
        return appId === 'historical2' /*AA*/
            && Number(ko.unwrap(tabId)) === 0 /*first tab - Dashboard*/
            && _.isEmpty(tabPrefs.panels) /* for dashboard-style tabs */
            && _.isEmpty(tabPrefs.fixedpanels); /* for table-style tabs */
    }

    function CleanUpOptionsForSaving(options) {
        delete options.columnOptions;
        delete options.colOptionsDetail;
        delete options.colOptionsSummary;
        return options;
    }

    function GetOptionToSave(dashboardDataItem, options, obsparams) {
        return {
            x: dashboardDataItem.x,
            y: dashboardDataItem.y,
            componentType: dashboardDataItem.componentType,
            options: CleanUpOptionsForSaving(options),
            observableParams: obsparams,
            seq: dashboardDataItem.seq
        };
    }

    function GetObservableParamsList(dashboardDataItem) {
        var list = null;
        if (!_.isEmpty(_.get(dashboardDataItem, 'params.observableParamsList'))) {
            list = _.map(dashboardDataItem.params.observableParamsList, function (item) {
                return ko.unwrap(item);
            });
        }
        return list;
    }

    function getNextLocation(panelslist) {
        var filled = [];
        var templastRow = 0;
        var maxX = 4;

        panelslist.forEach(function (panelItem) {

            for (var i = 0; i < panelItem.height; i++) {
                for (var j = 0; j < panelItem.width; j++) {
                    filled.push({ row: panelItem.y + i, col: panelItem.x + j });
                    if (templastRow < (panelItem.y + panelItem.height)) {
                        templastRow = panelItem.y + panelItem.height;
                    }
                }
            }
        });

        var templastCol = 0;

        filled.forEach(function (filledItem) {
            if (filledItem.row === templastRow - 1) {
                if (filledItem.col >= templastCol) {
                    templastCol = filledItem.col + 1;
                }
            }
        });

        if (templastCol >= maxX) {
            templastCol = 0;
            templastRow++;
        }

        return { x: templastCol, y: templastRow };
    }

    function getNextLocationFromPanelPreferences(panels) {
        var loc = { x: 0, y: 0 };

        panels.forEach(function(panel) {
            if (panel.y > loc.y) {
                loc.y = panel.y;
            }
        });

        if (loc.y > 0) {
            loc.y += 5;//height
        }

        return loc;
    }

    DashboardCommon.prototype.addNewTab = function (tabsList) {
        var self = this;

        var newTabId = generateUID();
        var newTabName = getDefaultTabName(tabsList);

        return self.preferenceManager.saveTabPreferences(self.currentAppId,
                self.currentViewId,
                newTabId,
                { id: newTabId, name: newTabName, panels: [] });
    };

    DashboardCommon.prototype.deleteTab = function (tabId) {
        var self = this;
        return self.preferenceManager.deleteTab(self.currentAppId, self.currentViewId, tabId);
    };

    DashboardCommon.prototype.logActivity2 = function (action, source, detail, data) {
        var self = this;
        self.dataProvider.logActivity2(action, source, detail, data);
    };

    DashboardCommon.prototype.saveCurrentTab = function () {
        var self = this;
        if (!self.externalPreferences) {
            return self.preferenceManager
                .getTabPreferences(self.prefAppId, self.currentViewId, self.currentTabId)
                .then(function (tabItem) {
                    // reset panels/fixedpanels, they will be rebuilt
                    if (tabItem) {
                        tabItem.panels = [];
                        tabItem.fixedpanels = [];
                    }
                    _.forEach(self.currentPanelsObservable(), function (dashboardDataItem) {
                        if (_.has(dashboardDataItem, 'params.observableOptions')) {
                            var options = _.merge({}, dashboardDataItem.params.observableOptions());
                            var obsparams = GetObservableParamsList(dashboardDataItem);
                            tabItem.panels.push(GetOptionToSave(dashboardDataItem, options, obsparams));
                        }
                    });

                    if (self.currentTabFixedObservable) {
                        var currentFixedTab = ko.unwrap(self.currentTabFixedObservable);
                        tabItem.fixedpanels = _.map(currentFixedTab, function (fixedItem) {
                            var fixedoptions = _.merge({}, ko.unwrap(_.get(fixedItem, 'params.observableOptions')));
                            var fixedobsparams = GetObservableParamsList(fixedItem);
                            return GetOptionToSave(fixedItem, fixedoptions, fixedobsparams);
                        });
                    }

                    return self.preferenceManager
                        .saveTabPreferences(self.prefAppId, self.currentViewId, self.currentTabId, tabItem);
                });
        }
    };

    DashboardCommon.prototype.saveTabPreferences = function (tabprefstosave) {
        var self = this;
        self.preferenceManager.getTabPreferences(self.prefAppId, self.currentViewId, self.currentTabId).then(function (tabprefs) {
            $.extend(true, tabprefs, tabprefstosave);

            self.currentTabId = tabprefs.id;
            self.currentTabName = tabprefs.name;

            self.preferenceManager.saveTabPreferences(self.prefAppId, self.currentViewId, self.currentTabId, tabprefs);
        });
    };

    DashboardCommon.prototype.GetTabsList = function () {
        var self = this;
        return self.preferenceManager.getListOfTabs(self.prefAppId, self.currentViewId);
    };

    DashboardCommon.prototype.saveViewPreferences = function (viewprefstosave) {
        var self = this;
        self.preferenceManager.getViewPreferences(self.prefAppId, self.currentViewId).then(function(viewprefs) {
            $.extend(true, viewprefs, viewprefstosave);
            self.preferenceManager.saveViewPreferences(self.prefAppId, self.currentViewId, viewprefs);
        });
    };

    DashboardCommon.prototype.getViewPreferences = function () {
        var self = this;
        return self.preferenceManager.getViewPreferences(self.prefAppId, self.currentViewId);
    };

    DashboardCommon.prototype.getTabPreferences = function () {
        var self = this;
        return self.preferenceManager.getTabPreferences(self.prefAppId, self.currentViewId, self.currentTabId);
    };

    DashboardCommon.prototype.processPreferences = function(tabId, viewLevelOptions, tabprefs){
        var self = this;

        self.currentTabName = tabprefs.name;
        return self.CreateComponents(tabprefs.panels, viewLevelOptions).then(function (components) {
            self.currentPanelsObservable(components);
            if (tabprefs.fixedpanels) {
                return self.CreateComponents(tabprefs.fixedpanels, viewLevelOptions).then(function (fixedcomponents) {
                    self.loadMode = false;
                    fixedcomponents.sort(function(a, b) { return ((a.seq && b.seq && (a.seq < b.seq)) ? -1 : 1); });
                    self.currentTabFixedObservable(fixedcomponents);
                });
            }
            else {
                self.currentTabFixedObservable([]);
                self.loadMode = false;
            }
        });
    };

    DashboardCommon.prototype.LoadTabPanels = function (tabId, viewLevelOptions, tabprefs2) {
        var self = this;
        self.loadMode = true;

        self.UnRegisterCurrentPanels();

        self.currentTabId = ko.unwrap(tabId);

        if (tabprefs2){
            //prevent saving changes if preferences are external (from shared link)
            self.externalPreferences = true;
            return self.processPreferences(tabId, viewLevelOptions, tabprefs2);
        }

        self.externalPreferences = false;

        return self.preferenceManager.getTabPreferences(self.prefAppId, self.currentViewId, self.currentTabId).then(function (tabprefs) {
            // Add default panels to empty AA first tabs (UI-1236)
            // Only check for views that start with "historical2", which will get the main AA panels but not click-through charts
            if (!_.includes(window.location.href.toLowerCase(), '/params/') && isEmptyAAFirstTab(self.prefAppId, tabId, tabprefs)) {
                return self.preferenceManager.getDefaultAdvancedAnalyticsPreferences().then(function (defaultAAPrefs) {
                    // set default panels for empty first tabs in Advanced Analytics (AA)
                    tabprefs = getAAViewDefaultPrefs(defaultAAPrefs, self.currentViewId);
                    self.preferenceManager.saveTabPreferences(self.prefAppId, self.currentViewId, ko.unwrap(tabId), tabprefs);
                    return self.processPreferences(tabId, viewLevelOptions, tabprefs);
                });
            }
            else {
                return self.processPreferences(tabId, viewLevelOptions, tabprefs);
            }
        });
    };

    DashboardCommon.prototype.makeObservableParams = function(panel) {
        var observableParamsList = [];
        var foundobsparam = false;
        panel.dataSources.forEach(function (dsItem) {

            if (dsItem.params.observableParams) {
                foundobsparam = true;
                if (dsItem.params.obsParamsInitValue) {
                    observableParamsList.push(ko.observable(dsItem.params.obsParamsInitValue));
                }
                else {
                    observableParamsList.push(ko.observable({}));
                }
            }
            else {
                observableParamsList.push({});
            }
        });

        if (!foundobsparam) {
            observableParamsList = [];
        }

        return observableParamsList;
    };

    DashboardCommon.prototype.CreateComponents = function (panelPreferences, viewLevelOptions) {
        var self = this;

        if (!panelPreferences || $.isEmptyObject(panelPreferences)) {
            return Promise.resolve([]);
        }
        else {
            var list = [];

            panelPreferences.forEach(function(dashboardDataItem) {
                var positionObj = { x: dashboardDataItem.x, y: dashboardDataItem.y };
                var options = dashboardDataItem.options;
                var id = options.id;
                var panelTemplate = dashboardDataItem.componentType;
                var panelTemplateObj = $.extend(true, {}, self.panelFactory.getPanelFromType(panelTemplate));
                let base = {
                    dataFormatter: {
                        params: {
                            appId: self.currentAppId,
                            viewId: self.currentViewId,
                            tabId: self.currentTabId
                        }
                    }
                };
                var panel = self.CreatePanelFromTemplate(panelTemplateObj, options, id, base);
                var observableParamsList = self.makeObservableParams(panel);

                let dataHandle = self.Register(panel, observableParamsList);
                var component = self.GetComponent(panel, dataHandle);
                component.x = positionObj.x;
                component.y = positionObj.y;
                component.params.observableParamsList = observableParamsList;
                component.params.viewLevelOptions = viewLevelOptions;
                component.seq = dashboardDataItem.seq;
                list.push(component);
            });

            return Promise.resolve(list);
        }
    };

    DashboardCommon.prototype.Register = function (panel, observableParamsList) {
        var self = this;

        if (observableParamsList && !$.isEmptyObject(observableParamsList)) {
            for (var i = 0; i < panel.dataSources.length; i++) {
                if (panel.dataSources[i].params.observableParams) {
                    panel.dataSources[i].observableParams = observableParamsList[i];
                }
            }
        }

        var dataConsumerObject = { id: panel.observableOptions().id, observableOptions: panel.observableOptions };

        self.dataProvider.registerDataConsumer(dataConsumerObject, panel.dataSources, panel.dataFormatter);
        return self.dataProvider.getObservableData(dataConsumerObject);
    };

    DashboardCommon.prototype.UnRegisterCurrentPanels = function() {
        var self = this;

        self.currentPanelsObservable().forEach(function(component) {
            self.dataProvider.unregisterDataConsumer(component.id);
            delete component.params;
            delete component.observableParams;
        });

        if (self.currentTabFixedObservable && self.currentTabFixedObservable()) {
            self.currentTabFixedObservable().forEach(function(component) {
                self.dataProvider.unregisterDataConsumer(component.id);
                delete component.params;
                delete component.observableParams;
            });
        }
    };

    DashboardCommon.prototype.getNextPanelId = function () {
        var self = this;
        var idstr = String.fromCharCode(Math.floor((Math.random() * 25) + 65));

        do {
            // between numbers and characters (48 is 0 and 90 is Z (42-48 = 90)
            var ascicode = Math.floor((Math.random() * 42) + 48);
            if (ascicode < 58 || ascicode > 64) {
                // exclude all chars between : (58) and @ (64)
                idstr += String.fromCharCode(ascicode);
            }
        } while (idstr.length < 32);

        self.nextPanelId = idstr;

        return self.nextPanelId;
    };

    DashboardCommon.prototype.getSystemDictionaryObservable = function () {
        var self = this;
        return self.dataProvider.getSystemDictionaryObservable();
    };

    DashboardCommon.prototype.CreatePanelFromTemplate = function (panelTemplateObj, panelOptions, panelId, base) {
        var self = this;
        var panel = {};
        var options = {};
        $.extend(true, panel, base, panelTemplateObj);
        $.extend(options, panelTemplateObj.defaultOptions);
        $.extend(options, panelOptions);
        options.id = panelId ? panelId : self.getNextPanelId();

        panel.observableOptions = ko.observable(options);

        self.subscriptions.push(panel.observableOptions.subscribe(function (newvalue) {
            if (!self.loadMode) {
                self.logActivity2("saveOptions", '', '', '');
                self.saveCurrentTab();
            }
        }));

        return panel;
    };

    DashboardCommon.prototype.AddComponentToActiveDashboard = function (component) {
        var self = this;

        var nextPosition = getNextLocation(self.currentPanelsObservable());

        component.x = nextPosition.x;
        component.y = nextPosition.y;

        self.currentPanelsObservable.push(component);

        return nextPosition;
    };

    DashboardCommon.prototype.removeComponentFromActiveDashboard = function (compId) {
        var self = this;

        self.logActivity2("removingPanelFromDashboard", '', '', { panelId: compId });

        self.currentPanelsObservable.remove(function (item) { return item.params.observableOptions().id === compId; });
    };

    DashboardCommon.prototype.copyComponentToTab = function (compId, targetTab) {
        var self = this;

        var compToCopy = ko.utils.arrayFirst(self.currentPanelsObservable(), function (item) {
            return (item.params.observableOptions().id === compId);
        });

        if (!compToCopy) {
            return;
        }

        var options = $.extend(true, {}, compToCopy.params.observableOptions());
        var obsparams = GetObservableParamsList(compToCopy);

        self.preferenceManager.getTabPreferences(targetTab.appId, targetTab.viewId, targetTab.id).then(function(tabprefs) {
            var nextPosition = getNextLocationFromPanelPreferences(tabprefs.panels);

            compToCopy.x = nextPosition.x;
            compToCopy.y = nextPosition.y;

            options.id = self.getNextPanelId();
            tabprefs.panels.push(GetOptionToSave(compToCopy, options, obsparams));

            self.preferenceManager.saveTabPreferences(targetTab.appId, targetTab.viewId, targetTab.id, tabprefs);

            alert('Panel has been added to your dashboard');
        });
    };

    DashboardCommon.prototype.GetComponent = function (panel, observableDataHandle) {
        var self = this;

        var comp = {
            id: panel.observableOptions().id,
            name: panel.widgetType,
            componentType: panel.panelType,
            params: {
                observableData: observableDataHandle,
                observableOptions: panel.observableOptions,
                panelTemplate: panel,
                deletedSignal: new Signals.Signal(),
                resizeSignal: new Signals.Signal(),
                copyPanelSignal: new Signals.Signal()
            },
            height: panel.height,
            width: panel.width
        };

        comp.params.deletedSignal.add(function(id) { self.removeComponentFromActiveDashboard(id); });

        comp.params.copyPanelSignal.add(function (id, target) {
            self.copyComponentToTab(id, target);
        });

        return comp;
    };

    DashboardCommon.prototype.dispose = function () {
        var self = this;

        self.UnRegisterCurrentPanels();

        self.subscriptions.forEach(function(sub) {
            sub.dispose();
        });
    };

    export default DashboardCommon;
